import { ReactNode } from 'react'

import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Divider,
  Button,
  useBreakpointValue
} from '@chakra-ui/react'

interface ModalConfirmConsultTimeProps {
  children: ReactNode
  title: string
  onCreate: () => void
  isOpen: boolean
  onClose: () => void
  isLoading: boolean
}

export const ModalConfirmConsultTime = ({
  children,
  title,
  onCreate,
  isOpen,
  onClose,
  isLoading
}: ModalConfirmConsultTimeProps) => {
  const isWideVersion = useBreakpointValue({
    base: false,
    lg: true
  })

  return (
    <>
      <Modal
        size={isWideVersion ? 'lg' : 'md'}
        blockScrollOnMount={false}
        isCentered
        key={title}
        isOpen={isOpen}
        onClose={onClose}
      >
        <ModalOverlay />
        <ModalContent maxH="90vh">
          <ModalHeader>{title}</ModalHeader>
          <ModalCloseButton />
          <Divider />
          <ModalBody overflowY="auto">{children}</ModalBody>
          <ModalFooter>
            <Button variant="ghost" mr={3} onClick={onClose}>
              Fechar Consulta
            </Button>
            <Button isLoading={isLoading} disabled={isLoading} colorScheme="blue" onClick={onCreate}>
              Consultar horários
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}
